module.exports = __webpack_public_path__ + "assets/img/4f221f8f07deda774dd7db973c1a6a7d.svg";